import styled from "styled-components";
import React from "react";

const CardWrapper = styled.div`
  height: 300px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;

  @media only screen and (max-width: 1000px) {
    height: auto;
    width: 300px;
  }
  @media only screen and (max-width: 500px) {
    width: 250px;
  }
`;

const CardImg = styled.img`
  height: 300px;
  width: 300px !important;
  @media only screen and (max-width: 1000px) {
    width: 100% !important;
    height: 300px;
  }
  @media only screen and (max-width: 500px) {
    height: 250px;
  }
`;

const Card = props => (
  <>
    <CardWrapper className="card hoverable horizontal hide-on-med-and-down">
      <div className="card-image">
        <CardImg src={props.imgurl} />
      </div>
      <div className="card-stacked">
        <div style={{ textAlign: "left", position: "relative" }} className="card-content">
          <img style={{ position: "absolute", height: "70px", opacity: "0.6" }} src="/quote.svg" />
          <br />
          <br />
          <h6 style={{ paddingLeft: "30px", paddingTop: "10px" }}>{props.body}</h6>
          <br />
          <p
            style={{
              paddingLeft: "40px",
              fontSize: "15px",
              color: "#667988",
              fontWeight: "300",
              letterSpacing: "1.1px"
            }}
          >
            {props.name}
          </p>
          <p
            style={{
              paddingLeft: "40px",
              fontSize: "15px",
              color: "#667988",
              fontWeight: "300",
              letterSpacing: "1.1px"
            }}
          >
            {props.college}
          </p>
        </div>
      </div>
    </CardWrapper>
    <CardWrapper className="card hoverable hide-on-large-only">
      <div className="card-image">
        <CardImg src={props.imgurl} />
      </div>
      <div className="card-stacked">
        <div style={{ textAlign: "left", position: "relative" }} className="card-content">
          <img style={{ position: "absolute", height: "70px", opacity: "0.6" }} src="/quote.svg" />
          <br />
          <h6 style={{ paddingLeft: "40px", paddingTop: "10px" }}>{props.body}</h6>
          <br />
          <p
            style={{
              fontSize: "15px",
              color: "#667988",
              fontWeight: "300",
              letterSpacing: "1.1px"
            }}
          >
            {props.name}
          </p>
          <p
            style={{
              fontSize: "15px",
              color: "#667988",
              fontWeight: "300",
              letterSpacing: "1.1px"
            }}
          >
            {props.college}
          </p>
        </div>
      </div>
    </CardWrapper>
  </>
);

export default Card;
